import axios from 'axios';
import Cookies from 'js-cookie';

// Replace this with your actual backend base URL if it's different
export const API_BASE_URL = 'https://pms.burraypayroll.co.zw';

// Create an axios instance that you can import and use across your application
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = Cookies.get('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;
